import { apiInstance, gql } from "@/services/httpAdapter";
import { errorLogger } from "@Common/helpers/logger";

export async function getAutoAlertsSetupsById({ locationId, listId }) {
	const query = gql`
		query getAutoAlertsSetupsById($locationId: String!, $_id: String!) {
			getAutoAlertsSetupsById(locationId: $locationId, _id: $_id) {
				_id
				title
				commissionCycleId
				createdOn
				effectiveDateFrom
				effectiveDateTo
				itemsCount
				createdBy {
					_id
					fullName
				}
				lastModifiedBy {
					_id
					fullName
				}
				lastModifiedOn
				items {
					_id
					alertDate
					createdAt
					createdBy {
						fullName
					}
					actionType {
						_id
						description
						customerInitiated
					}
					activityType {
						_id
						description
					}
					associationWindow
					commission {
						input
						value
					}
					createdAt
					initiatedBy
					lastModifiedOn
				}
			}
		}
	`;

	const variables = {
		locationId,
		_id: listId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getAutoAlertsSetupsById;
	} catch (err) {
		errorLogger(err, {
			function: "getAutoAlertsSetupsById",
			message: "Error getting auto alerts setups by id",
			variables,
		});
		return null;
	}
}

export async function getCommissionCyclesAutoAlertsSetup({ locationId }) {
	const query = gql`
		query getCommissionCyclesAutoAlertsSetup($locationId: String!) {
			getCommissionCyclesAutoAlertsSetup(locationId: $locationId) {
				_id
				endDate
				startDate
				status
				title
				autoAlertsSetups {
					autoAlertsSetupId {
						_id
						commissionCycleId
						itemsCount
						title
						effectiveDateFrom
						effectiveDateTo
						lastModifiedBy {
							_id
							fullName
						}
						createdBy {
							_id
							fullName
						}
						lastModifiedOn
						createdOn
					}
				}
			}
		}
	`;

	const variables = {
		locationId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getCommissionCyclesAutoAlertsSetup;
	} catch (err) {
		errorLogger(err, {
			function: "getCommissionCyclesAutoAlertsSetup",
			message: "Error getting commission cycles auto alerts setup",
			variables,
		});
		return null;
	}
}

export async function getAdministrationToolsOpportunityMining(locationId) {
	const query = gql`
		query getAdministrationTools($locationId: String!) {
			getAdministrationTools(locationId: $locationId) {
				_id
				integrations {
					opportunityMining {
						_id
						provider {
							_id
							providerName
							configuration {
								associationWindow
							}
						}
					}
				}
			}
		}
	`;

	const variables = {
		locationId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getAdministrationTools;
	} catch (err) {
		errorLogger(err, {
			function: "getAdministrationTools",
			message: "Error getting administration tools",
			variables,
		});
		return null;
	}
}

export async function getOpportunityMiningProviderInfo(locationId, providerName) {
	const query = gql`
		query getOpportunityMiningProviderInfo($locationId: String!, $providerName: String!) {
			getOpportunityMiningProviderInfo(locationId: $locationId, providerName: $providerName) {
				provider
				providerLegalName
				providerName
				qualifyingActivityActionPairs {
					_id
					activityType {
						_id
						description
						actionType {
							_id
							customerInitiated
							description
						}
					}
				}
			}
		}
	`;

	const variables = {
		locationId,
		providerName,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getOpportunityMiningProviderInfo;
	} catch (err) {
		errorLogger(err, {
			function: "getOpportunityMiningProviderInfo",
			message: "Error getting opportunity mining provider info",
			variables,
		});
		return null;
	}
}

export async function getAutoAlertsItems(locationId, commissionCycleId, inputFilter) {
	const query = gql`
		query getAutoAlertsItems($locationId: String!, $commissionCycleId: String!, $filter: AutoAlertsItemsFilterInput) {
			getAutoAlertsItems(locationId: $locationId, commissionCycleId: $commissionCycleId, filter: $filter) {
				_id
				date
				customer
				amount
				stockNumber
				saleType
				lastActivityDate
				actionType
				initiatedBy
				associationWindow
			}
		}
	`;

	const variables = {
		locationId,
		commissionCycleId,
		filter: inputFilter,
	};

	try {
		const { data } = await apiInstance.post("/graphql", { query, variables });
		return data.data?.getAutoAlertsItems;
	} catch (err) {
		errorLogger(err, { function: "getAutoAlertsItems", message: "Error getting auto alerts items", variables });
		return null;
	}
}
